var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnesideViewBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 64,
    viewBox: "0 0 84 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 56,
    height: 64,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 32C38 31.4477 37.5523 31 37 31H25.83L30.71 26.12C31.1017 25.7283 31.1006 25.0928 30.7075 24.7025C30.3164 24.3141 29.6848 24.3152 29.295 24.705L23.4142 30.5858C22.6332 31.3668 22.6332 32.6332 23.4142 33.4142L29.2947 39.2947C29.6842 39.6842 30.3158 39.6842 30.7053 39.2947C31.0946 38.9054 31.0949 38.2743 30.7059 37.8847L25.83 33H37C37.5523 33 38 32.5523 38 32Z",
    fill: "#212529",
    stroke: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 32C46 31.4477 46.4477 31 47 31H58.17L53.29 26.12C52.8983 25.7283 52.8994 25.0928 53.2925 24.7025C53.6836 24.3141 54.3152 24.3152 54.705 24.705L60.5858 30.5858C61.3668 31.3668 61.3668 32.6332 60.5858 33.4142L54.7053 39.2947C54.3158 39.6842 53.6842 39.6842 53.2947 39.2947C52.9054 38.9054 52.9051 38.2743 53.2941 37.8847L58.17 33H47C46.4477 33 46 32.5523 46 32Z",
    fill: "#212529",
    stroke: "#212529"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnesideViewBig);
export default __webpack_public_path__ + "static/media/oneside-view-big.53a64551.svg";
export { ForwardRef as ReactComponent };